import {
  FETCH_DS1_CATALOGUE_LIST,
  RESET_DS1_CATALOGUE_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const ds1CatalogueListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_CATALOGUE_LIST:
      return { list: action.payload, others: action.others };
    case RESET_DS1_CATALOGUE_LIST: {
      return initialState;
    }
    default:
      return state;
  }
};

export default ds1CatalogueListReducer;
